import { BulletList, BriefSection, SectionHead } from "./BriefPrimitives";

export interface InputGroup {
  title: string;
  items?: string[];
}

function cleanItems(items?: string[]): string[] {
  return (items ?? []).map((item) => item?.trim()).filter((item): item is string => !!item);
}

/**
 * A titled group of bullets in a four-column grid (two on tablets, one on
 * phones). Empty groups drop out; the section drops out when all are empty.
 */
export function BulletGroups({ groups }: { groups: InputGroup[] }) {
  const filled = groups
    .map((group) => ({ title: group.title, items: cleanItems(group.items) }))
    .filter((group) => group.items.length);
  if (!filled.length) return null;
  return (
    <div className="grid grid-cols-1 gap-7 @[36rem]/briefdoc:grid-cols-2 @[52rem]/briefdoc:grid-cols-4">
      {filled.map((group) => (
        <div key={group.title} className="min-w-0">
          <p className="text-[13px] font-semibold text-co-text">{group.title}</p>
          <BulletList items={group.items} className="mt-2" />
        </div>
      ))}
    </div>
  );
}

export function BriefInputs({
  props,
  wardrobe,
  locations,
  talent,
  crew,
}: {
  props?: string[];
  wardrobe?: string[];
  locations?: string[];
  talent?: string[];
  crew?: string[];
}) {
  const groups: InputGroup[] = [
    { title: "Props and products", items: props },
    { title: "Wardrobe", items: wardrobe },
    { title: "Location", items: locations },
    { title: "Talent", items: talent },
    { title: "Crew", items: crew },
  ];
  if (!groups.some((group) => cleanItems(group.items).length)) return null;
  return (
    <BriefSection accent="purple">
      <SectionHead accent="purple" title="Production inputs" tight />
      <BulletGroups groups={groups} />
    </BriefSection>
  );
}
